export default __webpack_public_path__ + "static/media/Tiger's Belt of the Roaring Jungle.0064f09b.jpg";